<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot-scope="scope" slot="menu">
                <el-button  class="View" @click="revocationBtn(scope.row)" v-if="scope.row.ct_status==3||scope.row.ct_status==4">作废</el-button>
                <el-button  class="View" @click="deleteBtn(scope.row)" v-if="scope.row.ct_status==0">删除</el-button>
                <el-button  class="View" @click="saveEvidence(scope.row)" v-if="scope.row.ct_status==5">保存证据</el-button>
            </template>
        </avue-crud>
<!--        作废-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <span>请确认是否要作废该案件</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </span>
        </el-dialog>
<!--        删除-->
        <el-dialog
                title="提示"
                :visible.sync="deleteData"
                :close-on-click-modal="false"
                width="30%">
            <span>删除合同后，会归还发起失败的合同份数</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteData = false">取 消</el-button>
                <el-button type="primary" @click="determineBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { contractList, contractSearch, revocationContract } from '../../../api/contract';
    import { sendFailure } from '../../../api/templateList';

    export default {
        inject: ['reload'],
        name: "initiate",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                dialogVisible:false,
                deleteData:false, //删除 弹框
                data: [],
                doc_title:'',
                all_signers:'',
                id:'',
                signer_list_id:'',
                option:{
                    align:'center',
                    menuAlign:'center',
                    editBtn:false,
                    delBtn:false,
                    menuWidth:300,//操作栏宽度设置
                    rowKey:'ids',
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn:false, //左上角新增
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn',
                        },  {
                            label:'合同编号',
                            prop:'contract_sn',
                        },  {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time'
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label:'合同完成时间',
                            prop:'finish_time'
                        },  {
                            label: '签署截止时间',
                            prop: 'expire_time'
                        }

                    ]
                },
            };
        },
        methods:{
            // 搜索
            searchChange(from,done){
                contractSearch(1,10,1,from.doc_title,from.all_signers).then(res=>{
                    this.doc_title=from.doc_title
                    this.all_signers=from.all_signers
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers==''){
                    contractList(1,10,num).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                    })
                }else {
                    //搜索后分页
                    contractSearch(1,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }

            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                contractList(1,10,1).then(res=>{
                    this.data=res.data.list
                    this.page.total=res.data.count
                    this.page.currentPage=1
                })
            },
            //作废
            revocationBtn(row){
                this.dialogVisible=true
                this.id=row.id

            },
            //确认作废
            confirmBtn(){
                revocationContract(this.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //删除按钮
            deleteBtn(row){
                this.signer_list_id=row.id
                this.deleteData=true
            },
            //确认删除
            determineBtn(){
                sendFailure(this.signer_list_id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            saveEvidence(row){
                this.$router.push({path:'/evidenceList',query:{id:row.id,is_main:'1'}})

            }
        },
        created() {
           this.resetChange()
        }
    }
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .View{
        background: #3d62f6;
        color: #fff;
    }
</style>
